// Finley Theme Main JS Script
document.addEventListener('DOMContentLoaded', function () {
  initSlideshow();
  initCartDrawer();
  initAccordions();
  initMobileMenu();
  initHeaderSearch();
  initProductPage();
  initPredictiveSearch();
  initStickyScrolls();
});

/* =========================================================================
   1. Slideshow
   ========================================================================= */
function initSlideshow() {
  const containers = document.querySelectorAll('.slideshow-container');
  containers.forEach(container => {
    // Clear any existing autoplay timer stored on this container
    if (container.autoplayTimer) {
      clearInterval(container.autoplayTimer);
    }

    const slides = container.querySelectorAll('.slide-item');
    if (slides.length === 0) return;

    const wrapper = container.querySelector('.slideshow-wrapper');
    let currentIndex = 0;
    const slideDuration = 4500;

    function showSlide(index) {
      slides.forEach((slide, idx) => {
        slide.classList.toggle('active', idx === index);
      });
      if (wrapper) {
        wrapper.style.transform = `translateX(-${index * 100}%)`;
      }
      currentIndex = index;
    }

    function nextSlide() {
      let nextIndex = (currentIndex + 1) % slides.length;
      showSlide(nextIndex);
    }

    function prevSlide() {
      let prevIndex = (currentIndex - 1 + slides.length) % slides.length;
      showSlide(prevIndex);
    }

    // Swipe Gestures Support
    let touchStartX = 0;
    let touchEndX = 0;

    container.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    container.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });

    function handleSwipe() {
      const swipeThreshold = 50; // minimum pixels to swipe
      if (touchEndX < touchStartX - swipeThreshold) {
        // Swiped left -> next slide
        if (container.autoplayTimer) clearInterval(container.autoplayTimer);
        nextSlide();
        startAutoplay();
      } else if (touchEndX > touchStartX + swipeThreshold) {
        // Swiped right -> prev slide
        if (container.autoplayTimer) clearInterval(container.autoplayTimer);
        prevSlide();
        startAutoplay();
      }
    }

    function startAutoplay() {
      container.autoplayTimer = setInterval(nextSlide, slideDuration);
    }

    showSlide(0);
    startAutoplay();
  });
}

/* =========================================================================
   2. AJAX Cart Drawer Operations & Flying Animation
   ========================================================================= */
function initCartDrawer() {
  const backdrop = document.querySelector('.cart-drawer-backdrop');
  const drawer = document.querySelector('.cart-drawer');
  const openButtons = document.querySelectorAll('#cart-icon-btn, .cart-trigger');
  const closeButtons = document.querySelectorAll('.cart-drawer-backdrop, .drawer-header button, .close-cart');

  if (!drawer) return;

  // Toggle Drawer Display
  function openCart() {
    backdrop.classList.add('active');
    drawer.classList.add('active');
    refreshCartDrawer();
  }

  function closeCart() {
    backdrop.classList.remove('active');
    drawer.classList.remove('active');
  }

  openButtons.forEach(btn => btn.addEventListener('click', function (e) {
    e.preventDefault();
    openCart();
  }));

  closeButtons.forEach(btn => btn.addEventListener('click', function (e) {
    e.preventDefault();
    closeCart();
  }));

  window.openShopifyCartDrawer = openCart;

  // Bind Add-to-Cart Buttons statically and dynamically
  document.body.addEventListener('click', function (e) {
    const atcBtn = e.target.closest('.ajax-add-to-cart');
    if (!atcBtn) return;

    e.preventDefault();
    const form = atcBtn.closest('form') || document.querySelector('.product-form');
    if (!form) return;

    const variantId = form.querySelector('[name="id"]').value;
    const qty = form.querySelector('[name="quantity"]')?.value || 1;
    const imgUrl = atcBtn.getAttribute('data-image') || '';

    // Trigger animation
    const btnRect = atcBtn.getBoundingClientRect();
    if (imgUrl) {
      triggerFlyingAnimation(imgUrl, btnRect);
    }

    // Shopify Add Item API
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: qty
      })
    })
    .then(res => res.json())
    .then(item => {
      // Re-fetch cart & slide open cart drawer
      setTimeout(() => {
        openCart();
      }, 750);
    })
    .catch(err => console.error('Error adding to cart:', err));
  });
}

// Flying animation implementation
function triggerFlyingAnimation(imgSrc, fromRect) {
  const cartIcon = document.querySelector('#cart-icon-btn');
  if (!cartIcon) return;
  const cartRect = cartIcon.getBoundingClientRect();

  const flyer = document.createElement('div');
  flyer.style.position = 'fixed';
  flyer.style.left = `${fromRect.left + fromRect.width / 2 - 24}px`;
  flyer.style.top = `${fromRect.top + fromRect.height / 2 - 24}px`;
  flyer.style.width = '48px';
  flyer.style.height = '48px';
  flyer.style.zIndex = '99999';
  flyer.style.borderRadius = '50%';
  flyer.style.overflow = 'hidden';
  flyer.style.border = '2px solid #1b2f74';
  flyer.style.boxShadow = '0 8px 32px rgba(0,0,0,0.2)';
  flyer.style.transition = 'none';

  const img = document.createElement('img');
  img.src = imgSrc;
  img.style.width = '100%';
  img.style.height = '100%';
  img.style.objectFit = 'cover';
  flyer.appendChild(img);

  document.body.appendChild(flyer);

  // Trigger animation next frame
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      flyer.style.transition = 'transform 0.75s cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 0.75s ease';
      const distX = cartRect.left + cartRect.width / 2 - (fromRect.left + fromRect.width / 2);
      const distY = cartRect.top + cartRect.height / 2 - (fromRect.top + fromRect.height / 2);
      flyer.style.transform = `translate(${distX}px, ${distY}px) scale(0.1)`;
      flyer.style.opacity = '0';
    });
  });

  // Remove flyer after animation finished
  setTimeout(() => {
    flyer.remove();
    // Bounce cart icon a bit
    cartIcon.classList.add('animate-bounce-slow');
    setTimeout(() => cartIcon.classList.remove('animate-bounce-slow'), 1000);
  }, 800);
}

// Refresh Drawer Content
function refreshCartDrawer() {
  const container = document.querySelector('.drawer-items-list');
  if (!container) return;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      // Update header counter
      const bubble = document.querySelector('#cart-icon-btn span');
      if (bubble) {
        bubble.textContent = cart.item_count > 9 ? '9+' : cart.item_count;
        if (cart.item_count > 0) {
          bubble.style.backgroundColor = '#ef4444';
        } else {
          bubble.style.backgroundColor = '#18181b';
        }
      }

      // If empty
      if (cart.items.length === 0) {
        container.innerHTML = `
          <div style="display:flex; flex-direction:column; align-items:center; justify-content:center; height:100%; gap:1rem; color:#a1a1aa; padding:2rem; text-align:center;">
            <svg style="width:64px; height:64px; opacity:0.2;" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
              <line x1="3" y1="6" x2="21" y2="6"/>
              <path d="M16 10a4 4 0 0 1-8 0"/>
            </svg>
            <p style="font-size:13px; font-weight:900; text-transform:uppercase; letter-spacing:0.05em;">Your cart is empty</p>
            <button class="close-cart" style="background:#1b2f74; color:#ffffff; font-weight:900; font-size:11px; text-transform:uppercase; letter-spacing:0.05em; padding:10px 24px; border-radius:8px;">Continue Shopping</button>
          </div>
        `;
        const footer = document.querySelector('.drawer-footer');
        if (footer) footer.style.display = 'none';
        return;
      }

      // Render Items
      let html = '';
      cart.items.forEach(item => {
        const itemSubtotal = (item.line_price / 100).toFixed(2);
        html += `
          <div class="drawer-item" data-id="${item.key}">
            <div class="drawer-item-img">
              <img src="${item.image}" alt="${item.product_title}">
            </div>
            <div class="drawer-item-info">
              <p class="drawer-item-title">${item.product_title}</p>
              ${item.variant_title ? `<p style="font-size:10px; color:#a1a1aa; margin-top:-4px; margin-bottom:8px; font-weight:600;">${item.variant_title}</p>` : ''}
              <div class="qty-selectors">
                <button onclick="updateDrawerQty('${item.key}', ${item.quantity - 1})">-</button>
                <span>${item.quantity}</span>
                <button onclick="updateDrawerQty('${item.key}', ${item.quantity + 1})">+</button>
              </div>
            </div>
            <div class="drawer-item-right">
              <button class="drawer-item-remove" onclick="updateDrawerQty('${item.key}', 0)">✕</button>
              <span class="drawer-item-price">₹${itemSubtotal}</span>
            </div>
          </div>
        `;
      });

      // Upsell logic based on customizer-selected products
      const upsell1 = window.themeAssets?.upsell_1;
      const upsell2 = window.themeAssets?.upsell_2;
      
      const hasUpsell1 = upsell1 && upsell1.variant_id && upsell1.available && !cart.items.some(i => i.variant_id == upsell1.variant_id);
      const hasUpsell2 = upsell2 && upsell2.variant_id && upsell2.available && !cart.items.some(i => i.variant_id == upsell2.variant_id);

      if (hasUpsell1 || hasUpsell2) {
        html += `
          <div class="drawer-upsell-container">
            <p class="upsell-heading">Pair it with</p>
        `;
        
        if (hasUpsell1) {
          html += `
            <div class="upsell-card" style="display:flex">
              <div class="upsell-img">
                <img src="${upsell1.image || ''}" alt="${upsell1.title}">
              </div>
              <div style="flex:1; min-width:0;">
                <p class="upsell-title">${upsell1.title}</p>
                <div class="upsell-pricing">
                  <span class="upsell-price">${upsell1.price}</span>
                  ${upsell1.original_price ? `<span class="upsell-price-original">${upsell1.original_price}</span>` : ''}
                </div>
              </div>
              <button class="upsell-add-btn" data-variant-id="${upsell1.variant_id}">Add</button>
            </div>
          `;
        }
        
        if (hasUpsell2) {
          html += `
            <div class="upsell-card" style="display:flex">
              <div class="upsell-img">
                <img src="${upsell2.image || ''}" alt="${upsell2.title}">
              </div>
              <div style="flex:1; min-width:0;">
                <p class="upsell-title">${upsell2.title}</p>
                <div class="upsell-pricing">
                  <span class="upsell-price">${upsell2.price}</span>
                  ${upsell2.original_price ? `<span class="upsell-price-original">${upsell2.original_price}</span>` : ''}
                </div>
              </div>
              <button class="upsell-add-btn" data-variant-id="${upsell2.variant_id}">Add</button>
            </div>
          `;
        }
        
        html += `</div>`;
      }

      container.innerHTML = html;

      // Update Footer Prices
      const footer = document.querySelector('.drawer-footer');
      if (footer) {
        footer.style.display = 'block';
        document.querySelector('.drawer-subtotal-val').textContent = `₹${(cart.total_price / 100).toFixed(2)}`;
      }

      // Bind Upsell Buttons
      container.querySelectorAll('.upsell-add-btn').forEach(btn => {
        btn.addEventListener('click', function(e) {
          const varId = btn.getAttribute('data-variant-id');
          if (!varId) return;
          btn.textContent = 'Adding...';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: varId, quantity: 1 })
          })
          .then(res => res.json())
          .then(() => refreshCartDrawer())
          .catch(err => console.error(err));
        });
      });
    });
}

// Global functions for inline onClick event handlers
window.updateDrawerQty = function (key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: key,
      quantity: qty
    })
  })
  .then(res => res.json())
  .then(() => {
    refreshCartDrawer();
  })
  .catch(err => console.error(err));
};

/* =========================================================================
   3. Accordions
   ========================================================================= */
function initAccordions() {
  document.body.addEventListener('click', function(e) {
    const trigger = e.target.closest('.faq-trigger, .prod-accordion-trigger');
    if (!trigger) return;

    e.preventDefault();
    const item = trigger.closest('.faq-item, .prod-accordion-item');
    if (!item) return;

    const isActive = item.classList.contains('active');
    
    // Optional: close other accordions in the same list
    const siblingList = item.parentElement.children;
    for (let sibling of siblingList) {
      sibling.classList.remove('active');
    }

    if (!isActive) {
      item.classList.add('active');
    }
  });
}

/* =========================================================================
   4. Mobile Menu Drawer
   ========================================================================= */
function initMobileMenu() {
  const burger = document.querySelector('button[aria-label="Toggle menu"]');
  const menuContainer = document.querySelector('.mobile-slide-down-menu');
  if (!burger || !menuContainer) return;

  burger.addEventListener('click', function(e) {
    e.preventDefault();
    const isOpen = menuContainer.style.display === 'block';
    if (isOpen) {
      menuContainer.style.display = 'none';
      burger.innerHTML = `
        <svg class="w-6 h-6 stroke-[2]" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <line x1="3" y1="12" x2="21" y2="12"></line>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <line x1="3" y1="18" x2="21" y2="18"></line>
        </svg>
      `;
    } else {
      menuContainer.style.display = 'block';
      burger.innerHTML = `
        <svg class="w-6 h-6 stroke-[2]" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      `;
    }
  });
}

/* =========================================================================
   4.5. Header Search Trigger
   ========================================================================= */
function initHeaderSearch() {
  const searchToggleBtn = document.getElementById('search-toggle-btn');
  const mobileSearchBar = document.getElementById('mobile-search-bar');
  if (!searchToggleBtn || !mobileSearchBar) return;

  searchToggleBtn.addEventListener('click', function(e) {
    e.preventDefault();
    const isOpen = mobileSearchBar.style.display === 'block';
    if (isOpen) {
      mobileSearchBar.style.display = 'none';
      searchToggleBtn.innerHTML = `
        <svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
      `;
    } else {
      mobileSearchBar.style.display = 'block';
      searchToggleBtn.innerHTML = `
        <svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      `;
      const searchInput = mobileSearchBar.querySelector('input[type="search"]');
      if (searchInput) searchInput.focus();
    }
  });
}

/* =========================================================================
   5. Product Page Gallery & Variants
   ========================================================================= */
function initProductPage() {
  // Gallery Thumbnails
  const thumbs = document.querySelectorAll('.gallery-thumbnail');
  const mainImage = document.querySelector('.gallery-main-image img');
  if (thumbs.length > 0 && mainImage) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', function(e) {
        e.preventDefault();
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        mainImage.src = thumb.getAttribute('data-image-src');
      });
    });
  }

  // Variant swatches select logic
  const options = document.querySelectorAll('.variant-option-pill');
  const hiddenSelect = document.getElementById('product-select');
  if (options.length > 0 && hiddenSelect) {
    options.forEach(option => {
      option.addEventListener('click', function(e) {
        e.preventDefault();
        
        const parentGrid = option.closest('.variant-options-grid');
        parentGrid.querySelectorAll('.variant-option-pill').forEach(pill => pill.classList.remove('active'));
        
        option.classList.add('active');
        
        // Update price display, image, and select value
        const variantId = option.getAttribute('data-variant-id');
        const price = option.getAttribute('data-price');
        const comparePrice = option.getAttribute('data-compare-price');
        const imageSrc = option.getAttribute('data-image');
        
        hiddenSelect.value = variantId;

        // Update main pricing UI
        if (price) {
          const displayPrice = document.querySelector('.prod-price');
          if (displayPrice) displayPrice.textContent = `₹${price}`;
        }
        if (comparePrice) {
          const displayCompare = document.querySelector('.prod-compare-price');
          if (displayCompare) displayCompare.textContent = `₹${comparePrice}`;
        }
        
        // Swap image
        if (imageSrc && mainImage) {
          mainImage.src = imageSrc;
          // select thumbnail
          thumbs.forEach(thumb => {
            if (thumb.getAttribute('data-image-src') === imageSrc) {
              thumb.click();
            }
          });
        }
      });
    });
  }

  // Quantity controls on main product page
  const qtyMinus = document.querySelector('.qty-btn-minus');
  const qtyPlus = document.querySelector('.qty-btn-plus');
  const qtyInput = document.querySelector('.qty-input-box');

  if (qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener('click', function(e) {
      e.preventDefault();
      let val = parseInt(qtyInput.value) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });

    qtyPlus.addEventListener('click', function(e) {
      e.preventDefault();
      let val = parseInt(qtyInput.value) || 1;
      qtyInput.value = val + 1;
    });
  }
}

/* =========================================================================
   6. Predictive Search Autocomplete
   ========================================================================= */
function initPredictiveSearch() {
  const searchInputs = document.querySelectorAll('.predictive-search-input');
  if (searchInputs.length === 0) return;

  searchInputs.forEach(input => {
    // Add dynamic container for results under search bars
    const resultsContainer = document.createElement('div');
    resultsContainer.className = 'predictive-search-results';
    resultsContainer.style.position = 'absolute';
    resultsContainer.style.left = '0';
    resultsContainer.style.right = '0';
    resultsContainer.style.background = '#ffffff';
    resultsContainer.style.border = '1px solid #e4e4e7';
    resultsContainer.style.borderRadius = '8px';
    resultsContainer.style.maxHeight = '300px';
    resultsContainer.style.overflowY = 'auto';
    resultsContainer.style.display = 'none';
    resultsContainer.style.zIndex = '999';
    resultsContainer.style.padding = '8px 12px';
    resultsContainer.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
    input.parentElement.style.position = 'relative';
    input.parentElement.appendChild(resultsContainer);

    input.addEventListener('keyup', function(e) {
      const term = input.value.trim();
      if (term.length < 2) {
        resultsContainer.style.display = 'none';
        return;
      }

      fetch(`/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=4`)
        .then(res => res.json())
        .then(data => {
          const products = data.resources.results.products;
          if (products.length === 0) {
            resultsContainer.innerHTML = `<p style="font-size:11px; font-weight:800; color:#a1a1aa; text-transform:uppercase;">No products found</p>`;
            resultsContainer.style.display = 'block';
            return;
          }

          let html = '';
          products.forEach(p => {
            html += `
              <a href="${p.url}" style="display:flex; align-items:center; gap:8px; padding:6px 0; border-bottom:1px solid #f4f4f5; text-decoration:none; color:inherit;">
                <img src="${p.image}" style="width:40px; height:40px; border-radius:4px; object-fit:contain;" alt="">
                <div>
                  <p style="font-size:12px; font-weight:800; text-transform:uppercase; margin:0; line-height:1.2;">${p.title}</p>
                  <p style="font-size:11px; font-weight:900; color:#09090b; margin:0;">₹${p.price}</p>
                </div>
              </a>
            `;
          });
          resultsContainer.innerHTML = html;
          resultsContainer.style.display = 'block';
        })
        .catch(err => console.error(err));
    });

    // Close predictive results when clicking outside
    document.addEventListener('click', function(e) {
      if (!input.contains(e.target) && !resultsContainer.contains(e.target)) {
        resultsContainer.style.display = 'none';
      }
    });
  });
}

/* =========================================================================
   7. Sticky Scroll Elements (Mobile buy bar & Header effects)
   ========================================================================= */
function initStickyScrolls() {
  window.addEventListener('scroll', function () {
    const stickyAtcBar = document.querySelector('.mobile-sticky-footer-bar');
    const mainAtcBtn = document.querySelector('.product-info-panel .add-to-cart-btn');

    if (stickyAtcBar && mainAtcBtn) {
      const btnPosition = mainAtcBtn.getBoundingClientRect().bottom;
      
      // If original ATC button is scrolled out of view, slide in the sticky bar
      if (btnPosition < 0) {
        stickyAtcBar.classList.add('active');
      } else {
        stickyAtcBar.classList.remove('active');
      }
    }
  });
}

// Force checkout redirect on button clicks to bypass any form/customizer submit blocks
document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('click', function(e) {
    const checkoutBtn = e.target.closest('.drawer-checkout-btn, button[name="checkout"]');
    if (!checkoutBtn) return;
    
    e.preventDefault();
    window.location.href = '/checkout';
  });
});

// Shopify Customizer Section Load Event Handlers
document.addEventListener('shopify:section:load', function(e) {
  if (e.target.querySelector('.slideshow-container')) {
    initSlideshow();
  }
});

document.addEventListener('shopify:block:select', function(e) {
  const slideItem = e.target.closest('.slide-item');
  if (slideItem) {
    const container = slideItem.closest('.slideshow-container');
    if (container) {
      if (container.autoplayTimer) {
        clearInterval(container.autoplayTimer); // pause autoplay
      }
      const slides = Array.from(container.querySelectorAll('.slide-item'));
      const index = slides.indexOf(slideItem);
      if (index !== -1) {
        slides.forEach((slide, idx) => {
          slide.classList.toggle('active', idx === index);
        });
        const wrapper = container.querySelector('.slideshow-wrapper');
        if (wrapper) {
          wrapper.style.transform = `translateX(-${index * 100}%)`;
        }
      }
    }
  }
});

document.addEventListener('shopify:block:deselect', function(e) {
  const slideItem = e.target.closest('.slide-item');
  if (slideItem) {
    const container = slideItem.closest('.slideshow-container');
    if (container) {
      // resume autoplay
      const slides = container.querySelectorAll('.slide-item');
      let currentIndex = Array.from(slides).findIndex(s => s.classList.contains('active'));
      if (currentIndex === -1) currentIndex = 0;
      
      const wrapper = container.querySelector('.slideshow-wrapper');
      
      if (container.autoplayTimer) clearInterval(container.autoplayTimer);
      container.autoplayTimer = setInterval(function() {
        let nextIndex = (currentIndex + 1) % slides.length;
        slides.forEach((slide, idx) => {
          slide.classList.toggle('active', idx === nextIndex);
        });
        if (wrapper) {
          wrapper.style.transform = `translateX(-${nextIndex * 100}%)`;
        }
        currentIndex = nextIndex;
      }, 4500);
    }
  }
});
